import { Box, Link } from '@mui/material';
import withStyles from '@mui/styles/withStyles';
import {RowFlexContainer} from '../FlexComponents'
import * as React from 'react'
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined'
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined'
import DeleteForeverIcon from '@mui/icons-material/DeleteForever'
import EditIcon from '@mui/icons-material/Edit'
import PrintIcon from '@mui/icons-material/Print'
import CancelIcon from '@mui/icons-material/Lock'
import {Colors} from '../Constants'
import {LinkProps} from '@mui/material/Link/Link'

interface Props {
    to?: string
    linkColor?: Colors
    disabled?: boolean
}

export const StyledLink = (props: LinkProps & Props) => {
    const {to, linkColor, ...rest} = props
    const href = props.to || props.href
    const linkElement =
        <Link
            {...rest}
            href={href}
            component={href ? 'a' : 'button'}
            variant={'body2'}
            type={href ? undefined : 'button'}
            color={linkColor ? 'inherit' : 'primary'}
            underline="hover">
            <RowFlexContainer>{props.children}</RowFlexContainer>
        </Link>

    return (
        linkColor ?
            <Box color={linkColor}>{linkElement}</Box> :
            <>{linkElement}</>
    )
}

export const CustomStyledLink = withStyles({
    root: {
        '&:disabled': {
            color: Colors.Disabled,
            cursor: 'default',
            textDecoration: 'none',
        }
    }
})(StyledLink)

export const BackLink = (props: LinkProps & Props) => (
    <StyledLink {...props}>
        <ArrowBackIosOutlinedIcon/> {props.children}
    </StyledLink>
)

export const ForwardLink = (props: LinkProps & Props) => (
    <StyledLink {...props}>
        {props.children} <ArrowForwardIosOutlinedIcon/>
    </StyledLink>
)

export const DeleteLink = (props: LinkProps & Props) => (
    <CustomStyledLink {...props}>
        <DeleteForeverIcon/> {props.children}
    </CustomStyledLink>
)

export const EditLink = (props: LinkProps & Props) => (
    <StyledLink {...props}>
        <EditIcon/> {props.children}
    </StyledLink>
)

export const PrintLink = (props: LinkProps & Props) => (
    <StyledLink {...props}>
        <PrintIcon/> {props.children}
    </StyledLink>
)

export const CancelLink = (props: LinkProps & Props) => (
    <StyledLink {...props}>
        <CancelIcon/> {props.children}
    </StyledLink>
)

export const InlineLink = withStyles({
    root: {
        color: Colors.AdminPrimary,
    },
})(Link)
